import axios from "axios";
import { getAdminKey, clearAdminKey } from "./auth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const API_TIMEOUT_MS = 30_000;

export const api = axios.create({ baseURL: API, timeout: API_TIMEOUT_MS });

api.interceptors.request.use((config) => {
  const key = getAdminKey();
  if (key) config.headers["Authorization"] = `Bearer ${key}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      clearAdminKey();
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export const getBusinesses = () => api.get("/businesses").then(r => r.data);
export const getBusiness = (slug) => api.get(`/businesses/${slug}`).then(r => r.data);
export const submitPitch = (payload) => api.post("/pitch", payload).then(r => r.data);
export const discover = (query) => api.post("/discover", { query }).then(r => r.data);
export const getBoroughs = () => api.get("/boroughs").then(r => r.data);
export const bulkDiscover = (borough, trades) => api.post("/bulk-discover", { borough, trades }, { timeout: 180_000 }).then(r => r.data);
export const bulkExportUrl = (sessionId) => `${API}/bulk-discover/${sessionId}/export`;
export const listLeadJobs = () => api.get("/lead-jobs").then(r => r.data);
export const createLeadJob = (payload) => api.post("/lead-jobs", payload).then(r => r.data);
export const deleteLeadJob = (id) => api.delete(`/lead-jobs/${id}`).then(r => r.data);
export const runLeadJobNow = (id) => api.post(`/lead-jobs/${id}/run-now`).then(r => r.data);
export const getJobSessions = (id) => api.get(`/lead-jobs/${id}/sessions`).then(r => r.data);
export const createDemo = (payload) => api.post("/demo", payload, { timeout: 150_000 }).then(r => r.data);
export const approveDemoBrief = (id, brief) => api.post(`/demo/${id}/approve`, { brief }, { timeout: 180_000 }).then(r => r.data);
export const getDemo = (id) => api.get(`/demo/${id}`).then(r => r.data);
export const getDemoSiteUrl = (id) => `${API}/demo/${id}/site`;
export const getDemoPublicUrl = (d, fallbackId) => d?.public_url || getDemoSiteUrl(d?.id || fallbackId);
export const backfillPublishDemos = () => api.post("/demo/backfill-publish").then(r => r.data);

export const logout = () => api.post("/auth/logout").catch(() => {}).then(() => {
  clearAdminKey();
  window.location.href = "/admin/login";
});

export const listProspects = () => api.get("/prospects").then(r => r.data);
export const createProspect = (payload) => api.post("/prospects", payload).then(r => r.data);
export const updateProspect = (id, payload) => api.patch(`/prospects/${id}`, payload).then(r => r.data);
export const deleteProspect = (id) => api.delete(`/prospects/${id}`).then(r => r.data);
export const generateOutreach = (id) => api.post(`/prospects/${id}/outreach`, {}, { timeout: 30000 }).then(r => r.data);
export const unsubscribeUrl = (id) => `${API}/unsubscribe/${id}`;
export const verifyProspectWebsite = (id) => api.post(`/prospects/${id}/verify-website`, {}, { timeout: 30000 }).then(r => r.data);
export const verifyRawWebsite = (name, address, borough) => api.post("/verify-website", { name, address, borough }, { timeout: 30000 }).then(r => r.data);
